module.exports = __webpack_public_path__ + "static/media/use13.0ba22675.jpeg";